export { default } from '@/components/UI/Text';
